module.exports = __webpack_public_path__ + "static/media/user.f0245e39.svg";